import { appRoutes } from '../../shared/routes/app-routes';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ss-error-page',
  template: `
    <main class="ss-error-page" role="region" [attr.aria-labelledby]="'ss-error-title'">
      <div class="ss-error-page__top">
        <a [routerLink]="appRoutes.dashboard.home()" aria-label="SpotPass">
          <img src="assets/images/logo.svg" alt="SpotPass" class="ss-error-page__logo" />
        </a>
      </div>

      <section class="ss-error-page__card">
        <span class="ss-error-page__icon" [class.ss-error-page__icon--danger]="isForbidden" aria-hidden="true">
          <lucide-icon [name]="isForbidden ? 'shield-check' : 'circle-alert'" [size]="28"></lucide-icon>
        </span>

        <span class="ss-error-page__code">{{ isForbidden ? '403 · ACESSO RESTRITO' : '404 · NÃO ENCONTRADA' }}</span>

        <h1 id="ss-error-title" class="ss-error-page__title">
          {{ isForbidden ? 'Você não tem permissão para acessar esta página' : 'Página não encontrada' }}
        </h1>

        <p class="ss-error-page__description">
          {{
            isForbidden
              ? 'Seu perfil não possui acesso a este módulo ou recurso. Caso precise de liberação, fale com o administrador do sistema.'
              : 'O endereço acessado não existe ou foi movido. Verifique a URL, procure a tela pelo menu ou use a busca do cabeçalho após voltar ao início.'
          }}
        </p>

        <div class="ss-error-page__actions">
          <a [routerLink]="appRoutes.dashboard.home()" class="ss-btn primary ss-error-page__btn">
            <lucide-icon name="arrow-left" [size]="16" aria-hidden="true"></lucide-icon>
            <span>Voltar para o início</span>
          </a>
        </div>
      </section>
    </main>
  `,
  standalone: false
})
export class ErrorPageComponent implements OnInit {
  readonly appRoutes = appRoutes;
  isForbidden = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const dataType = this.route.snapshot.data?.['errorType'];
    const queryType = this.route.snapshot.queryParamMap.get('type');
    this.isForbidden = dataType === 'forbidden' || queryType === 'forbidden' || queryType === '403';
  }
}
